import { fmtText } from '@kdk/shared';
import { tokens } from '@kdk/shared/theme';
import { Box, Button, Typography } from '@mui/material';
import { useAuth } from '../auth/AuthProvider';
import { ThemeModeToggle } from './ThemeModeToggle';

/** サイドバー下部: ログイン中のユーザー名と「ログアウト」。 */
export const UserBox = () => {
  const { user, logout } = useAuth();
  if (user === null) return null;
  return (
    <Box
      sx={{
        flex: 'none',
        display: 'flex',
        flexDirection: { xs: 'row', sm: 'column' },
        alignItems: { xs: 'center', sm: 'flex-start' },
        gap: { xs: '8px', sm: '6px' },
        ml: { xs: 'auto', sm: 0 },
        mt: { sm: '10px' },
        px: 1,
        pt: { sm: '12px' },
        borderTop: { sm: `1px solid ${tokens.sidebarLine}` },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          minWidth: 0,
          width: { sm: '100%' },
        }}
      >
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            noWrap
            title={user.name}
            sx={{ color: tokens.sidebarTx, fontSize: 13, fontWeight: 600 }}
          >
            {fmtText(user.name)}
          </Typography>
          {user.permissions.length === 0 && (
            <Typography sx={{ fontSize: 11.5, color: tokens.sidebarDim }}>閲覧のみ</Typography>
          )}
        </Box>
        <ThemeModeToggle />
      </Box>
      <Button
        size="small"
        variant="outlined"
        onClick={() => {
          void logout();
        }}
        sx={{
          color: tokens.sidebarMu,
          borderColor: tokens.sidebarLine2,
          whiteSpace: 'nowrap',
          '&:hover': { bgcolor: tokens.sidebarHover, borderColor: tokens.sidebarMu },
        }}
      >
        ログアウト
      </Button>
    </Box>
  );
};
